import { isMoveToManagementRouterEnabled } from '@helpcenter/feature-flags';
import { getMeta } from '@helpcenter/meta';
import type { RouterContext } from 'react-resource-router';
import { createHelpCenterAri } from 'utils/ari-parser';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import type { srcRovoServiceAgentSettingsQuery } from './__generated__/srcRovoServiceAgentSettingsQuery.graphql';
import srcRovoServiceAgentSettingsQueryArtifact from './__generated__/srcRovoServiceAgentSettingsQuery.graphql';

export const HelpCenterRovoServiceAgentResource = createRelayResource<srcRovoServiceAgentSettingsQuery>({
    type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
    getQuery: ({ match }: RouterContext, { cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string }) => {
        let computedHelpCenterAri = helpCenterAri;

        if (isMoveToManagementRouterEnabled()) {
            const activationId = getMeta('activation-id') || '';
            const helpCenterId = match.params.helpcenterId || '';
            computedHelpCenterAri = createHelpCenterAri(activationId, helpCenterId);
        }
        return {
            parameters: srcRovoServiceAgentSettingsQueryArtifact,
            variables: {
                cloudId,
                helpCenterAri: computedHelpCenterAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
